import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

import { useResolveLink } from '../../../../hooks/use-link-props';

export const useGenerateProduct = (isAdvancedSearch: boolean) => {
  const getHref = useResolveLink();
  const search = useSearchParams();

  return useCallback(
    (categorySlug: string, slug: string) => {
      const targetSearch = new URLSearchParams(search.toString());
      if (isAdvancedSearch) {
        targetSearch.set('prodCategory', categorySlug);
        targetSearch.set('prodSlug', slug);
      } else {
        targetSearch.set('category', categorySlug);
        targetSearch.set('subCategory', slug);
        if (!!search.get('subCategory')) {
          targetSearch.set(
            'searchSubCategory',
            search.get('subCategory') as string
          );
        }
      }
      return getHref(
        isAdvancedSearch ? 'advanced-search-product' : 'product',
        targetSearch.toString()
      );
    },
    [getHref, isAdvancedSearch, search]
  );
};
